import React, { useState, useEffect } from "react";
import { Modal, Form, Select, Button } from "antd";
import { useHistory } from "react-router-dom";

const { Option } = Select;

const listRole = [
    {
        role: "IMPORTIR",
        dok: ["20", "24"],
    },
    {
        role: "EKSPORTIR",
        dok: ["30", "301"],
    },
    {
        role: "TPB",
        dok: ["23", "25", "261", "262", "27", "40", "41"],
    },
    {
        role: "PLB",
        dok: ["16", "161", "261", "262", "27", "40", "41", "331"],
    },
    {
        role: "IMPORTIR PLB",
        dok: ["28", "281", "282"],
    },
    {
        role: "EKSPORTIR PLB",
        dok: ["33"],
    },
    {
        role: "PPJK",
        dok: ["20", "30", "23", "16", "28", "33", "511", "512", "513", "521", "522", "531", "161", "261", "262", "27", "40", "41", "331", "281", "282"],
    },
    {
        role: "FTZ",
        dok: ["511", "512", "513", "521", "522", "531"],
    },
];



const ModalNewDocs = ({ open, onClose }) => {
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedDok, setSelectedDok] = useState(null);
    const [availableDocs, setAvailableDocs] = useState([]);
    const history = useHistory();

    useEffect(() => {
        if (selectedRole) {
            const roleData = listRole.find((item) => item.role === selectedRole);
            setAvailableDocs(roleData ? roleData.dok : []);
            setSelectedDok(null); // Reset document selection when role changes
        } else {
            setAvailableDocs([]);
            setSelectedDok(null);
        }
    }, [selectedRole]);

    const handleOk = () => {
        console.log("Selected Role:", selectedRole);
        console.log("Selected Dokumen:", selectedDok);
        // alert(`DEBUG: Sending Role=${selectedRole}, Dokumen=${selectedDok}`);
        history.push(`/portal/dokumen-pabean/new?role=${selectedRole}&kodeDokumen=${selectedDok}`);
        onClose();
    };

    return (
        <Modal
            title="Pilih Dokumen Pabean"
            visible={open}
            onCancel={onClose}
            footer={[
                <Button key="back" onClick={onClose}>
                    Batal
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    disabled={!selectedRole || !selectedDok}
                    onClick={handleOk}
                >
                    Buat Dokumen
                </Button>,
            ]}
        >
            <Form layout="vertical">
                <Form.Item label="Entitas">
                    <Select
                        placeholder="Pilih Entitas"
                        onChange={(value) => setSelectedRole(value)}
                        value={selectedRole}
                    >
                        {listRole.map((item) => (
                            <Option key={item.role} value={item.role}>
                                {item.role}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item label="Kode Dokumen">
                    <Select
                        placeholder="Pilih Kode Dokumen"
                        onChange={(value) => setSelectedDok(value)}
                        value={selectedDok}
                        disabled={!selectedRole}
                    >
                        {availableDocs.map((dok) => (
                            <Option key={dok} value={dok}>
                                {dok}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ModalNewDocs;
